<script>
import { mapActions } from 'vuex';
import toggleModal from '@/mixins/toggleModal';
import dateFormat from '@/utils/dateFormat';

export default {
  data() {
    return {
      id: 0,
      type: 'gift_card',
      addedDate: '',
    };
  },
  props: {
    giftCardInfo: {
      type: Object,
      required: true,
    },
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      updateProductAction: 'products/updateProduct',
    }),
    handleOk(values) {
      this.updateProductAction({
        ...values,
        id: this.giftCardInfo.id,
        type: this.type,
      });
      this.hideModal();
    },
    dateFormat,
  },
};
</script>

<template>
  <div>
    <a-modal :open="show" :footer="null" @cancel="hideModal">
      <FormKit
        type="form"
        submit-label="Save"
        @submit="handleOk"
      >
        <h1 class="text-2xl font-bold mb-2">Edit gift card</h1>
        <h2>{{ giftCardInfo.displayName }}</h2>
        <h4><strong>Added date: </strong>{{ dateFormat(giftCardInfo.addedAt) }}</h4>
        <h4>
          <strong>Updated date: </strong>
          {{ giftCardInfo.updatedAt ? dateFormat(giftCardInfo.updatedAt) : '--/--/----'}}
        </h4>
        <FormKit
          type="text"
          name="displayName"
          label="Display name"
          placeholder="Display name"
          validation="required"
          :value="giftCardInfo.displayName"
        />
        <FormKit
          type="text"
          name="sku"
          label="Sku"
          placeholder="Sku"
          validation="required"
          :value="giftCardInfo.sku"
        />
        <FormKit
          type="number"
          number="integer"
          name="price"
          label="Price"
          placeholder="Enter price"
          validation="required"
          :value="giftCardInfo.price"
        />
      </FormKit>
    </a-modal>
  </div>
</template>

<style scoped lang="scss">

</style>
